import { module } from "modujs";

export default class extends module {
    constructor(m) {
        super(m);

        this.$currentItem = null

        this.events = {
            click: {
                toggler: 'toggle',
            },
        };
    }


    /**
    * Lifecycle
    */
    init() {
        this.bindEvents()
    }

    destroy() {
        super.destroy()

        this.unbindEvents()
    }


    /**
    * Binding
    */
    bindEvents() {
        this.resizeBind = this.onResize.bind(this)
        window.addEventListener('resize', this.resizeBind)
    }

    unbindEvents() {
        window.removeEventListener('resize', this.resizeBind)
    }


    /**
    * Callbacks
    */
    onOpen($item) {
        const $collapsible = $item.querySelector('[data-accordion="content"]')
        const $collasibleInner = $item.querySelector('[data-accordion="inner"]')

        if (!$collapsible || !$collasibleInner) return

        this.$currentItem = $item
        
        $item.classList.add('-open')

        const height = this.compute($collasibleInner).height
        gsap.to($collapsible, .3, { height, onComplete: () => {
            this.call('scrollTo', [$item, {offset: -10, duration: 1200}], 'Scroll')
        } })
    }

    onClose() { 
        if (!this.$currentItem) return

        const $collapsible = this.$currentItem.querySelector('[data-accordion="content"]')

        if (!$collapsible) return

        this.$currentItem.classList.remove('-open')

        gsap.to($collapsible, .3, {
            height: 0
        })
    }

    onResize() {
        if (!this.$currentItem) return

        const $collapsible = this.$currentItem.querySelector('[data-accordion="content"]')
        const $collasibleInner = this.$currentItem.querySelector('[data-accordion="inner"]')

        if (!$collapsible || !$collasibleInner) return
        
        const height = this.compute($collasibleInner).height
        $collapsible.style.height = `${height}px`
    }


    /**
    * Methods
    */  
    toggle(e) {
        const $item = e.curTarget
        const $accordionItem = $item.parentNode

        if($accordionItem.classList.contains('-open')) {
            this.onClose()
        } else {
            this.onClose()
            this.onOpen($accordionItem)
        }
    }

    compute(item) {
        return item.getBoundingClientRect()
    }
}
